var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M129.928,64.224V77.847a29.75,29.75,0,0,1-29.75,29.75h0a29.751,29.751,0,0,1-29.75-29.75V64.224a29.751,29.751,0,0,1,29.75-29.75h0A29.75,29.75,0,0,1,129.928,64.224ZM100,194.2c52.191,0,94.5-42.174,94.5-94.2S152.191,5.8,100,5.8,5.5,47.976,5.5,100,47.809,194.2,100,194.2ZM33.663,169.38c0-25.013,17.36-47.7,38.7-57.56l3.058,7.567,24.59,25.2,24.6-25.289,3.052-7.545a62.185,62.185,0,0,1,38.672,57.489"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8c132eda834b13527d6d01080a2c5cb5.svg";
export { ForwardRef as ReactComponent };